/**
 * @generated SignedSource<<be178adb6d87b687e0816da11919ef3d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeeSheetAgendaHeaderMobileNewFragment_club$data = {
  readonly facilities: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly displayNameOrFacilityName: string;
        readonly id: string;
        readonly name: string;
        readonly slug: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly logoImage: {
    readonly publicId: string;
  } | null | undefined;
  readonly name: string;
  readonly supportsPrivate: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"FacilityLogoFragment_club">;
  readonly " $fragmentType": "TeeSheetAgendaHeaderMobileNewFragment_club";
};
export type TeeSheetAgendaHeaderMobileNewFragment_club$key = {
  readonly " $data"?: TeeSheetAgendaHeaderMobileNewFragment_club$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeeSheetAgendaHeaderMobileNewFragment_club">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeeSheetAgendaHeaderMobileNewFragment_club",
  "selections": [
    (v0/*: any*/),
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FacilityLogoFragment_club"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "supportsPrivate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "logoImage",
      "plural": false,
      "selections": [
        {
          "alias": "publicId",
          "args": null,
          "kind": "ScalarField",
          "name": "renderingKey",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FacilityConnection",
      "kind": "LinkedField",
      "name": "facilities",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FacilityEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Facility",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "displayNameOrFacilityName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "slug",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Club",
  "abstractKey": null
};
})();

(node as any).hash = "bdee6463200ea8aa4b6e0302583eef5e";

export default node;
